module.exports = __webpack_public_path__ + "img/1254.c0b6d9a4.gif";